import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

// List of events. The event name will be what appears in the database.
export enum CreateContentTelemetryEvents {
  openMenu = 'CreateContentMenu_OpenMenu',
  selectItem = 'create_content_menu_select_item'
}

export interface CreateContentOpenMenuEvent extends ValidTelemetryEvent {
  type: CreateContentTelemetryEvents.openMenu;
  location: string;
}

export interface CreateContentSelectItemEvent extends ValidTelemetryEvent {
  type: CreateContentTelemetryEvents.selectItem;
  location: string;
  action_name: string;
}

export function sendCreateContentOpenMenuTelemetry(location: string) {
  Telemetry.sendEvent<CreateContentOpenMenuEvent>({
    type: CreateContentTelemetryEvents.openMenu,
    location
  });
}

export function sendCreateContentSelectItemTelemetry(location: string, actionName: string) {
  Telemetry.sendEvent<CreateContentSelectItemEvent>({
    type: CreateContentTelemetryEvents.selectItem,
    location,
    action_name: actionName
  });
}
